'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SKIN = exports.SKIN = 'SKIN';
var TOKEN = exports.TOKEN = 'TOKEN';
var MENUACTIVENAME = exports.MENUACTIVENAME = 'MENUACTIVENAME';
var MENUOPENNAME = exports.MENUOPENNAME = 'MENUOPENNAME';
var PAGE_SIZE = exports.PAGE_SIZE = 'PAGE_SIZE';
var MODEL_DISABLED = exports.MODEL_DISABLED = 'MODEL_DISABLED';
var CRUMBS_LIST = exports.CRUMBS_LIST = 'CRUMBS_LIST';
var MENU_LIST = exports.MENU_LIST = 'MENU_LIST';
var BIND_PHONE = exports.BIND_PHONE = 'BIND_PHONE';
var HELP_SELECTED = exports.HELP_SELECTED = 'HELP_SELECTED';
var LANGLIST = exports.LANGLIST = 'LANGLIST';